const NotFound = () => {
  return (
    <>Not found</>
  );
};

export default NotFound;
